'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
const StyledType = styled(Typography)(({ theme }) => ({
    color: theme.tokens.FuelColorGray800,
    paddingLeft: '0.25rem',
    paddingRight: '0.25rem'
}));
export const FooterListTitle = React.forwardRef(({ text, variant = 'h3', size = 'sm', ...props }, ref) => (_jsx(StyledType, { "data-fuel-size": size, noWrap: true, ref: ref, variant: variant, ...props, children: text })));
FooterListTitle.displayName = 'FooterListTitle';
